import { animation, animate, style } from '@angular/animations';

export const slideIn = animation([
    style({ transform: 'translateX(-100%)' }),
    animate('0.5s 100ms ease-in')
]);

export const slideOut = animation([
    animate('0.3s ease-out', style({ transform: 'translateX(100%)' }))
]);